import { SOCKET_SERVER_URL } from './../globals';
import { showAlertNotification } from './../notifications/alerts';
import * as socketio from 'socket.io-client';

let _socket: SocketIOClient.Socket | null;

const listenToAlertNotifications = (socket) => {
  socket.on('message', (event) => {
    if (event.message_type !== 'alert') {
      return;
    }
    showAlertNotification(event.data);
  });
};

const authenticateSocket = (socket) => {
  socket.emit('authentication', {});
};

export const setupSocket = () => {
  if (!SOCKET_SERVER_URL) {
    return;
  }

  // If socket is already setup, then return, so that socket is setup only once
  if (_socket) {
    console.log('socket already setup');
    return;
  }
  _socket = socketio(SOCKET_SERVER_URL);
  const socket = _socket;

  socket.on('connect', async () => {
    // Authenticate socket. Wait for authentication to be successful before subscribing things
    authenticateSocket(socket);
  });

  socket.on('authenticated', () => {
    console.log('socket is authenticated');

    // Temporary; Subscribe to test
    console.log('joining test');
    socket.emit('message', {
      message_type: 'join',
      subscription_type: 'test',
    });
  });

  socket.on('disconnect', () => {
    console.log('Socket disconnected');
  });

  // Listen to alerts
  listenToAlertNotifications(socket);
};

export const getSocket = () => {
  return _socket;
};

export const removeSocket = () => {
  if (_socket) {
    _socket.removeAllListeners();
    _socket.close();
    _socket = null;
  }
};
